import { LinkItem, JumboList } from "../components/JumboList";

const mainPages = [
  new LinkItem('/about', 'About'),
  new LinkItem('/portfolio', 'Portfolio'),
  new LinkItem('/writings', 'Writings'),
];

export default function Home() {
  return (
    <JumboList items={mainPages} height='h-64' />
  );
}